export class User {

    constructor(
      public username: string,
      public password: string,
      public name: string,
      public email: string,
      public role: string[]
    ) {}
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/common/model/user/user.model.ts